export default {
  // 获取手机验证码
  getAuthCode: '/amc/client/getAuthCode',
  // 手机验证码登录
  loginByPhone: '/amc/v1/loginByPhone',
  // 获取用户信息
  getMemberByToken: '/amc/client/getMemberByToken',
  // 微信授权登录后获取登录信息
  getWeixinMemberInfo: '/amc/client/getWeixinMemberInfo',
  //  qq登录
  getLoginData: '/amc/client/thirdLogin/getLoginData',
}